interface Step {
  label: string
  status: 'pending' | 'active' | 'completed'
}

interface ProgressIndicatorProps {
  steps: Step[]
}

const ProgressIndicator = ({ steps }: ProgressIndicatorProps) => {
  return (
    <div className="progress-container">
      <ul className="progress-steps">
        {steps.map((step, index) => (
          <li 
            key={index} 
            className={`progress-step ${step.status}`}
          >
            <div className={`step-icon ${step.status}`}>
              {step.status === 'completed' ? '✓' : index + 1}
            </div>
            <span className={`step-text ${step.status}`}>
              {step.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ProgressIndicator